/**
 * 📄 MembresiaPage.jsx
 * Página wrapper para membresías
 */
import React from "react";
import MembresiaList from "../components/Membresia/MembresiaList";

export default function MembresiaPage() {
    return <MembresiaList />;
}
